import { Box, ColorProps, HStack, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { AssetType } from '@blockpulse3/graphql/hooks';
import { formatNumberInt } from '@blockpulse3/helpers';

type Props = {
  /* ** Type of the Asset (AO, BSA...) ** */
  type: AssetType;
  /* ** Number of assets, if null, just info type rendered ** */
  value: number | null;
  /* ** Is badge grayed: for not attributed assets ** */
  grayed?: boolean;
};

const ASSET_COLOR_MAP: Record<AssetType, ColorProps['color']> = {
  ORDINARY_SHARE: 'indigo.700',
  PREFERRED_SHARE: 'purple.600',
  BSA: 'orange.600',
  BSA_AIR: 'pink.600',
  BSPCE: 'teal.700',
};

/**
 * AssetBadge.
 * Simple component, rendering a badge of desired asset type.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function AssetBadge({ type, value, grayed = false }: Props): JSX.Element {
  const i18nAssetValue = useTranslations('AssetTypeValues');

  return (
    <Box alignItems="center" bg="gray.100" px="2" py="0.5" rounded="md" width="fit-content">
      <HStack>
        <Text color={grayed ? 'gray.500' : ASSET_COLOR_MAP[type]} fontSize="sm">
          <Text as="span" fontWeight="700">
            {value || value === 0 ? `${formatNumberInt(value)} ` : ''}{' '}
          </Text>
          <Text as="span" fontSize="xs" fontWeight="600">
            {i18nAssetValue(type, { nb: value })}
          </Text>
        </Text>
      </HStack>
    </Box>
  );
}

export type AssetBadgeProps = Props;
